export default class HttpStatus {
    static OK = 200;
    static CREATED = 201;
    static NO_CONTENT = 204;
    static NOT_FOUND = 404;
    static UNPROCESSABLE_ENTITY = 422;
    static INTERNAL_SERVER_ERROR = 500;
}
